/** 推理框架 / 镜像系统配置 */
export const MAAS_SYSTEM_CONFIG_FIELD_KEYS = {
  framework: 'mi.framework',
  inferenceSource: 'mi.inferenceSource',
  inferenceSystem: 'mi.inferenceSystem',
  inferenceFrameworkImage: 'mi.inferenceFrameworkImage',
} as const;

export const MAAS_SYSTEM_CONFIG_FIELD_KEY_LIST = [
  MAAS_SYSTEM_CONFIG_FIELD_KEYS.framework,
  MAAS_SYSTEM_CONFIG_FIELD_KEYS.inferenceSource,
  MAAS_SYSTEM_CONFIG_FIELD_KEYS.inferenceSystem,
  MAAS_SYSTEM_CONFIG_FIELD_KEYS.inferenceFrameworkImage,
] as const;
